import React from 'react';
import ProductContainer from './Container';
import type { ProductCardProps } from './types';
import classNames from 'classnames';
import CardHeadVertical from './meta/card-head/card-head-vertical-lightning-home';
import CardBody from './meta/card-body/card-body-vertical-lightning-home';
import ProductAddCart from './meta/add-cart';
import LightningReminder from './meta/lightningReminder';
import EnchancedFavorite from './meta/enchanced-favorite';

const ProductVerticalLightningHome: React.FC<
  Partial<ProductCardProps> & { showProgress?: boolean; deliveryDate: string }
> = props => {
  const { className, data, ...rest } = props;
  return (
    <ProductContainer
      interactiveSlot={
        <div
          className="absolute right-0 top-0 w-full pointer-events-none"
          style={{
            paddingTop: '100%'
          }}>
          {props?.data?.status === 'begoing' && <EnchancedFavorite {...props} />}
          {data?.status === 'begoing' ? (
            <LightningReminder {...props} className="bottom-1 right-1 pointer-events-auto" date={props?.deliveryDate} />
          ) : (
            <ProductAddCart {...props} />
          )}
        </div>
      }
      data={data}
      {...rest}>
      <div className={classNames('p-0')}>
        <CardHeadVertical data={data} {...rest} showFavorite={false}>
          {/* {data?.status === 'begoing' ? (
            <LightningReminder {...props} className="bottom-1 right-1" />
          ) : (
            <ProductAddCart {...props} />
          )} */}
        </CardHeadVertical>
        <CardBody data={data} {...rest} />
      </div>
    </ProductContainer>
  );
};

export default ProductVerticalLightningHome;
